import { useEffect } from 'react';
import { useI18n } from '../i18n';
import Contact from './Contact';

export default function ContactAr() {
  const { setLang } = useI18n();

  useEffect(() => {
    setLang('ar');
  }, [setLang]);

  return <Contact />;
}
